import React from 'react';
import styles from "../../../index.module.scss";
import Global from '@/utils/global';

const CLink = ({ param, label }) => {
  return (
    <div className={styles.chatQuseListBox}>
      <div className={styles.jumpMenu} onClick={() => {
        Global.jumpTo(param.title, param.key, param.path, param.value)
      }}>{label}</div>
    </div>
  )
}

export default CLink;
